import { render, staticRenderFns } from "./clientuser.vue?vue&type=template&id=cebbd8b0&scoped=true&"
import script from "./clientuser.vue?vue&type=script&lang=js&"
export * from "./clientuser.vue?vue&type=script&lang=js&"
import style0 from "./clientuser.vue?vue&type=style&index=0&id=cebbd8b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebbd8b0",
  null
  
)

export default component.exports